import * as React from 'react'
import { Box } from '../box'

const Section = (props: any) => {
	const {
		gutter,
		...rest
	} = props

	return (
		<Box px={gutter ? 3 : 0} py={[4,null,5,null,6]} overflow="hidden" {...rest} />
	)
}

export default Section
